<template>
  <div class="hash-codes-list" :class="{ extendWidth: extendWidth }">
    <p>Use the following codes:</p>
    <ul>
      <li v-for="hash in computedHashCodes" :key="hash.hash">
        <tool-tip text="Copy" :textToCopy="sliceHash(hash.hash)"></tool-tip>
        <p class="remove--margin-bottom">{{ hash.hash }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import ToolTip from "@/components/GlobalComponents/ToolTip";

export default {
  components: {
    ToolTip,
  },
  props: {
    templateType: String,
    subject: {
      type: Boolean,
      default: false,
    },
    extendWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hashCodes: [
        { hash: "##firstname## (Guest firstname)" },
        { hash: "##hotel## (Hotel name)" },
        { hash: "##signature## (Email signature)" },
        { hash: "##link## (Link to Guest personal website)" },
        { hash: "##roomnumber## (Room number)" },
      ],
    };
  },
  created() {
    if (window.matchMedia("(max-width: 1030px)").matches) {
      this.hashCodes = [
        { hash: "##firstname##" },
        { hash: "##hotel##" },
        { hash: "##signature##" },
        { hash: "##link##" },
        { hash: "##roomnumber##" },
      ];
    }
  },
  computed: {
    computedHashCodes() {
      switch (this.templateType) {
        case "precheckin":
        case "pre-checkin":
          return this.hashCodes.slice(0, 4);
        case "checkin":
        case "check-in":
          return this.hashCodes;
        case "checkout":
        case "check-out":
          return this.hashCodes.slice(0, 3);
        case "afterstay":
        case "after-stay":
          return this.hashCodes.slice(0, 3);
        default:
          return this.hashCodes;
      }
    },
  },
  methods: {
    sliceHash(hashString) {
      return hashString.split(" ")[0];
    },
  },
};
</script>

<style scoped>
.hash-codes-list {
  display: inline-block;
  width: 30%;
  vertical-align: top;
}
.extendWidth {
  width: 100%;
}
p {
  text-align: left;
}
ul {
  list-style-type: none;
  text-align: left;
  padding: 0;
}
li {
  padding: 5px;
  display: flex;
  align-items: center;
}
.hash-codes-list > ul > li > p {
  font-size: 16px;
  margin-left: 5px;
}
@media (max-width: 769px) {
  .hash-codes-list {
    display: none;
  }
}
</style>
